export const data = {
    'Hip-hop':[
        {
            name:'Kaafizyada by Udhbhav',
            spotifyUrl:"https://open.spotify.com/track/7vvmU5ayTrVWiNVxiwHLQI",
            rating:'5/5'
        },
        
        {
            name:"Laga Reh by Talha Anjum",
            spotifyUrl:"https://open.spotify.com/track/7Dp2cvwS1migPssQvMFyQe?si=139d9efdcfc2450f",
            rating:'4/5'   
        },
        {
            name:"Disco Rap by Divine",
            spotifyUrl:"https://open.spotify.com/track/3l84vjvLnKIfqLLdZXKq2B?si=2cc46ad6bf46423e",
            rating:'3/5'
        }
        
        
    ],
    'Bollywood':[
        {
            name:'Ladki kyon',
            spotifyUrl:"https://open.spotify.com/track/0U9a0NZ8UQpnix2lBElFAx",
            rating:'5/5'
        },
        
        {
            name:"Kabhi Kabhi Aditi",
            spotifyUrl:"https://open.spotify.com/track/2XMoF2xSsQPiWLarBjk4xP",
            rating:'4/5'   
        },
        {
            name:"Chand Sifarish",
            spotifyUrl:"https://open.spotify.com/track/5EYZZvmNAH5VZCwuzYJqoA",
            rating:'4/5'
        }

    ],
    'Chill-lofi':[
        {
            name:'Dragon Force but is it okay if it is lofi? by Kijugo',
            spotifyUrl:"https://open.spotify.com/track/0cnRsDVV0HcCVDoDyTZodP?si=879f539639a248a3",
            rating:'5/5'
        },
        
        {
            name:"Unravel but is it okay if it is lofi? by Kijugo",
            spotifyUrl:"https://open.spotify.com/track/640GYv0XyB1r9QsylKGFOi?si=0b0bf2e4af7e4779",
            rating:'4/5'   
        },
        {
            name:"Options by Hippie Sabotage",
            spotifyUrl:"https://open.spotify.com/track/3kKbRNJmzSWdDgfKqJ9Eck?si=f642b57df8c04f85",
            rating:'3/5'
        }

    ]
}